/* eslint-disable no-console */
<template>
  <div>
    <div class="card z-depth-5 p-3">
      <h4 class="text-center font-weight-bold py-3">Edit Account</h4>
      <div>
        <!-- Default form login -->
        <form class="border border-light p-5">
          <div class="row">
            <div class="form-group col-md-12">
              <label>Title</label>
              <input
                type="text"
                ref="title"
                :value="teacher.title"
                class="form-control mb-4"
                placeholder="Title (Mr,Mrs,Miss,Master,Dr...)"
              />
            </div>
            <div class="form-group col-md-6">
              <label>First Name</label>
              <input
                type="text"
                ref="first_name"
                :value="teacher.first_name"
                class="form-control mb-4"
                placeholder="First Name"
              />
            </div>
            <div class="form-group col-md-6">
              <label>Last Name</label>
              <input
                type="text"
                ref="last_name"
                :value="teacher.last_name"
                class="form-control mb-4"
                placeholder="Last Name"
              />
            </div>
            <div class="form-group col-md-6">
              <label>City</label>
              <input
                type="text"
                ref="city"
                :value="teacher.city"
                class="form-control mb-4"
                placeholder="City"
              />
            </div>
            <div class="form-group col-md-6">
              <label>State</label>
              <input
                type="text"
                ref="county"
                :value="teacher.county"
                class="form-control mb-4"
                placeholder="State"
              />
            </div>
            <div class="form-group col-md-6">
              <label>Country</label>
              <input
                type="text"
                ref="country"
                :value="teacher.country"
                class="form-control mb-4"
                placeholder="Country"
              />
            </div>
            <div class="form-group col-md-6">
              <label>Email</label>
              <input
                type="email"
                ref="email"
                :value="teacher.email"
                class="form-control mb-4"
                placeholder="Email"
              />
            </div>
          </div>

          <!-- Sign in button -->
          <button class="btn btn-info btn-block my-4" @click.prevent="updateTeacher()">
            Update Account
          </button>
        </form>
        <!-- Default form login -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "AddTeacher",
  components: {},
  data() {
    return {
      user_id: this.$route.params.user_id,
      fastAdminToken: localStorage.getItem("fastAdminToken"),
      teacher: [],
    };
  },
  methods: {
    updateTeacher() {
      if (
        this.$refs.first_name.value == "" ||
        this.$refs.last_name.value == "" ||
        this.$refs.city.value == "" ||
        this.$refs.county.value == "" ||
        this.$refs.country.value == "" ||
        this.$refs.email.value == ""
      ) {
        this.$toast.open({
          message: "ERROR : All Fields Are Required",
          type: "error",
        });
      } else {
        let data = {
          first_name: this.$refs.first_name.value,
          last_name: this.$refs.last_name.value,
          city: this.$refs.city.value,
          county: this.$refs.county.value,
          country: this.$refs.country.value,
          email: this.$refs.email.value,
          title: this.$refs.title.value,
        };
        const config = {
          headers: {
            Authorization: "Bearer " + this.teacher.token,
            "Content-Type": "application/json",
          },
        };
        this.$toast.open({
          message: "Processing : Updating Teacher Please Wait...",
          type: "info",
        });
        axios
          .post(this.$apiURI + "/account/update", data, config)

          .then((response) => {
            if (response.data.error) {
              this.$toast.open({
                message: "Error : " + response.data.message,
                type: "error",
              });
            } else {
              this.$toast.open({
                message: "Teacher Updated Successfully",
                type: "success",
              });
            }
          })
          .catch((error) => {
            this.$toast.open({
              message: "Error : " + error.response.data.message,
              type: "error",
            });
          });
      }
    },
  },
  mounted() {
    this.$toast.open({
      message: "Processing : Loading Plan Please Wait...",
      type: "info",
    });

    const config = {
      headers: {
        Authorization: "Bearer " + this.fastAdminToken,
        "Content-Type": "application/json",
      },
    };
    axios
      .get(this.$apiURI + "/account/clone/" + this.user_id, config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          this.teacher = response.data.data;
          // this.planTarget = response.data.data.target
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });
  },
};
</script>
